import { IonItem } from '@ionic/react';
import { useHistory } from 'react-router';
import { NavLink } from 'react-router-dom';
import { Header } from '../components/Header';
import { IconButton } from '../components/IconButton';
import { IconActivity, IconArrowBack, IconCode, IconRocket, IconTerms } from '../components/QuirkIcons';
import { QuirkIonContent } from '../components/QuirkIonContent';
import { QuirkIonPage } from '../components/QuirkIonPage';
import { SiteLogoBanner } from '../components/SiteLogoBanner';
// eslint-disable-next-line css-modules/no-unused-class
import settingsStyles from '../components/SettingsMenu.module.css';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../styles/Shared.module.css';
import { useGetPublicInformationQuery } from '../api/SiteSettingsAPI.js';

export const AboutMenu = () => {
	const { data: siteSettings } = useGetPublicInformationQuery();
	const history = useHistory();
	return (
		<QuirkIonPage roles={['anonymous', 'user']} name="About Menu">
			<Header
				title={siteSettings?.siteName}
				left={<IconButton icon={<IconArrowBack />} onClick={() => history.go(-1)} />}
			/>

			<QuirkIonContent flush>
				<>
					<SiteLogoBanner />
					<div className={sharedStyles.pageContainer}>
						<div>
							<h2>{siteSettings?.siteName}</h2>
						</div>
						<div className={sharedStyles.pageDescription}>{siteSettings?.description}</div>

						<hr />

						<NavLink to="/main/settings/about/gettingstarted/" className="nounderline">
							<IonItem className={settingsStyles.ionItem}>
								<div className={settingsStyles.menuItemContainer}>
									<div className={settingsStyles.menuItemLabel}>
										<IconRocket />
									</div>
									<div className={settingsStyles.menuItemLabel}>Getting started</div>
								</div>
							</IonItem>
						</NavLink>
						<NavLink to="/main/settings/about/terms/" className="nounderline">
							<IonItem className={settingsStyles.ionItem}>
								<div className={settingsStyles.menuItemContainer}>
									<div className={settingsStyles.menuItemLabel}>
										<IconTerms />
									</div>
									<div className={settingsStyles.menuItemLabel}>Terms of service</div>
								</div>
							</IonItem>
						</NavLink>
						<NavLink to="/main/settings/about/algorithm/" className="nounderline">
							<IonItem className={settingsStyles.ionItem}>
								<div className={settingsStyles.menuItemContainer}>
									<div className={settingsStyles.menuItemLabel}>
										<IconActivity />
									</div>

									<div className={settingsStyles.menuItemLabel}>Algorithm explanation</div>
								</div>
							</IonItem>
						</NavLink>
						<NavLink to="/main/settings/about/howtoformatposts/" className="nounderline">
							<IonItem className={settingsStyles.ionItem}>
								<div className={settingsStyles.menuItemContainer}>
									<div className={settingsStyles.menuItemLabel}>
										<IconCode />
									</div>
									<div className={settingsStyles.menuItemLabel}>How to format posts</div>
								</div>
							</IonItem>
						</NavLink>
					</div>
				</>
			</QuirkIonContent>
		</QuirkIonPage>
	);
};
